var map = {
	"./": "ddBH",
	"./direct_select": "VNbL",
	"./direct_select.js": "VNbL",
	"./draw_line_string": "2ou6",
	"./draw_line_string.js": "2ou6",
	"./draw_point": "IZ5m",
	"./draw_point.js": "IZ5m",
	"./draw_polygon": "tj17",
	"./draw_polygon.js": "tj17",
	"./index": "ddBH",
	"./index.js": "ddBH",
	"./mode_interface": "k3LT",
	"./mode_interface.js": "k3LT",
	"./mode_interface_accessors": "EKEN",
	"./mode_interface_accessors.js": "EKEN",
	"./object_to_mode": "I6wr",
	"./object_to_mode.js": "I6wr",
	"./simple_select": "XNF7",
	"./simple_select.js": "XNF7"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "tzOA";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mapbox/mapbox-gl-draw/src/modes ^\.\/.*$
// module id = tzOA
// module chunks = 1